import React from 'react';
import '../styles/Footer.css'
import {Box, Grid, Link} from "@mui/material";
import {Typography} from "@material-ui/core";

const Footer = () => {
    return (
        <>
            <footer>
                <Box className='theBox'>
                    <Box className='gridContainer'>
                        <Grid container spacing={2}>
                            <Grid item md={5}>
                                <Typography variant='h4' style={{ textTransform: 'uppercase'}}>
                                    Hometutor
                                </Typography>
                                <Typography variant='h6' style={{ marginTop: '35px', maxWidth: '85%'}}>
                                    welcome to hometutor, a place where you could get the tutor you want and learn at your
                                    own pace
                                </Typography>
                            </Grid>
                            <Grid item md={2} className='gridWithLink' sx={{display: 'flex', flexDirection: 'column'}}>
                                <Typography variant='h4' className='linkHeader'>
                                    Company
                                </Typography>
                                <ul className="footer-links">
                                    <li><Link underline='hover' href="https://hometutor.co.tz/">About Us</Link></li>
                                    <li ><Link underline='hover' href="tel:+255 715 122 012">Tutor Register</Link></li>
                                    <li><Link underline='hover' href="tel:+255 715 122 012">Student Register</Link></li>
                                    <li><Link underline='hover' href="tel:+255 715 122 012">Packages</Link></li>
                                </ul>
                            </Grid>
                            <Grid item md={2} className='gridWithLink' sx={{display: 'flex', flexDirection: 'column'}}
                                  style={{ marginLeft: 30}}>
                                <Typography variant='h4' className='linkHeader'>
                                    Courses
                                </Typography>
                                <ul className="footer-links">
                                    <li><Link underline='hover' href="https://hometutor.co.tz/necta-classes/">Necta</Link></li>
                                    <li><Link underline='hover' href="https://hometutor.co.tz/">Cambridge</Link></li>
                                    <li><Link underline='hover' href="https://hometutor.co.tz/">IB</Link></li>
                                    <li><Link underline='hover' href="https://hometutor.co.tz/">Skillhub</Link></li>
                                </ul>
                            </Grid>
                            <Grid item md={2} className='gridWithLink' sx={{display: 'flex', flexDirection: 'column'}}>
                                <Typography variant='h4' className='linkHeader'>
                                    Past Papers
                                </Typography>
                                <ul className="footer-links">
                                    <li><Link underline='hover' href="https://hometutor.co.tz/past-papers-cambridge-levels/">Cambridge</Link></li>
                                    <li><Link underline='hover' href="https://hometutor.co.tz/">College Preps</Link></li>
                                    <li><Link underline='hover' href="https://hometutor.co.tz/">Necta</Link>
                                    </li>
                                    <li><Link underline='hover' href="https://hometutor.co.tz/">IB</Link></li>
                                </ul>
                            </Grid>
                        </Grid>
                        <hr/>
                        <Grid container style={{ marginTop: '18px'  }}>
                            <Grid item md={8} sm={6} xs={12} sx={{color: 'white'}}>
                                <Typography variant='h6'>
                                    Copyright &copy; {(new Date().getFullYear())} All Rights Reserved by <Link underline='always' href='https://hometutor.co.tz/' style={{ color: 'white'}}>Hometutor.co.tz</Link>

                                </Typography>

                            </Grid>
                            <Grid item md={4} sm={6} xs={12} sx={{ display: 'flex', flexDirection: 'row', justifyContent: {xs: 'center', sm: 'flex-end'}}}>
                                <Typography variant='h6'>
                                   <Link style={{ color: 'white', cursor: 'pointer'}}>
                                       Terms & Conditions
                                   </Link> &nbsp;&nbsp;&nbsp;&nbsp;
                                    <Link style={{ color: 'white', cursor: 'pointer'}}>
                                        Privacy Policy
                                    </Link>
                                </Typography>

                            </Grid>
                        </Grid>
                    </Box>
                </Box>
            </footer>
        </>
    );
};

export default Footer;